export default "__VITE_PUBLIC_ASSET__42d5f0d5__"